import { SaveQuestionnaireAnswerInput, SaveQuestionnaireAnswerItemInput, SaveQuestionnaireAnswerResponse } from '@/models/gen/graphql';

import { SaveQuestionnaireAnswerDocument } from '@/api/queries';
import graphApi from '@/api';

const [_, runSaveQuestionnaireAnswer] = graphApi(SaveQuestionnaireAnswerDocument);

export type EvaluationAnswers = Record<string, { optionId?: string; note?: string }>;

export const toSaveQuestionnaireAnswerItems = (answers: EvaluationAnswers): SaveQuestionnaireAnswerItemInput[] =>
  Object.entries(answers || {}).map(([questionId, { optionId, note }]) => ({
    questionnaireAttemptQuestionSnapshotId: questionId,
    selectedAnswerOptionSnapshotId: optionId,
    note,
  }));

export const saveQuestionnaireAnswer = async (answers: SaveQuestionnaireAnswerItemInput[]): Promise<SaveQuestionnaireAnswerResponse> => {
  const input: SaveQuestionnaireAnswerInput = { answers };
  const res = await runSaveQuestionnaireAnswer({ input });

  return res?.saveQuestionnaireAnswer;
};
